// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal-dialog[data-v-f06190a8] {\r\n  max-width: 600px !important;\n}\n[data-v-f06190a8] .first-checkbox .custom-control-label::before,[data-v-f06190a8] .first-checkbox .custom-control-label::after {\r\n  top: 1rem;\n}\r\n", ""]);
// Exports
module.exports = exports;
